import React from 'react';
import LocationOffIcon from '@material-ui/icons/LocationOff';
import './style.scss';
import LongTextTooltiper from "../../../Utils/LongTextTooltiper/LongTextTooltiper";

export default function OrderAddress(props) {
    const onClick = (e) => {
        if (!props.location && props.onBadAddressClick)
            props.onBadAddressClick(e);
    };

    return (
        <div className={"order-address" + (!props.location ? " order-address-error-location" : "")}
             onClick={onClick}>
            {
                !props.location ?
                    <span className="order-address-error-icon-container">
                        <LocationOffIcon fontSize="small"/>
                    </span>
                    :
                    null
            }
            <span className="order-address-text">
                <LongTextTooltiper backgroundColor="#efefef">
                    {props.address}
                </LongTextTooltiper>
            </span>
        </div>
    );
}